package co.maytes.standupbot.dashboard.components.marketing

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.max
import org.jetbrains.compose.web.attributes.min
import org.jetbrains.compose.web.attributes.step
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import kotlin.math.roundToInt

private const val DEFAULT_PEOPLE = 8
private const val DEFAULT_MINUTES = 10
private const val WORKDAYS_PER_WEEK = 5
private const val MINUTES_PER_HOUR = 60.0
private const val TENTHS = 10.0

@Composable
fun StandupTimeCalculator() {
    var people by remember { mutableStateOf(DEFAULT_PEOPLE) }
    var minutes by remember { mutableStateOf(DEFAULT_MINUTES) }
    val hours = ((people * minutes * WORKDAYS_PER_WEEK / MINUTES_PER_HOUR) * TENTHS).roundToInt() / TENTHS

    Div(attrs = { classes("mk-calc") }) {
        Div(attrs = { classes("mk-calc-controls") }) {
            CalcSlider("People on the team", people, 2, 50, 1) { people = it }
            CalcSlider("Minutes per person, per day", minutes, 5, 30, 5) { minutes = it }
        }
        Div(attrs = { classes("mk-calc-result"); attr("aria-live", "polite") }) {
            Span(attrs = { classes("mk-calc-figure") }) { Text("$hours") }
            P(attrs = { classes("mk-body") }) {
                Text("hours a week spent writing and reading standup updates. StandupBot writes them for you.")
            }
        }
    }
}

@Composable
private fun CalcSlider(label: String, value: Int, min: Int, max: Int, step: Int, onChange: (Int) -> Unit) {
    Label(attrs = { classes("mk-calc-field") }) {
        Span(attrs = { classes("mk-calc-label") }) {
            Text(label)
            Span(attrs = { classes("mk-calc-value") }) { Text("$value") }
        }
        Input(InputType.Range) {
            min("$min")
            max("$max")
            step(step.toDouble())
            value(value)
            onInput { event -> event.value?.toInt()?.let(onChange) }
        }
    }
}
